import React, { Fragment } from 'react';
import Divider from '@material-ui/core/Divider';
import Typography from "@material-ui/core/Typography";
import StaticDisplayMerit from './HelperChunks/StaticDisplayMerit';
const MeritScholarship = () => {

  return (
    <Fragment>
      <div style={{padding: 20}}>
          <Typography style={{ color: '#1d5f98', fontWeight: 600, fontSize: 20}} variant="h5">
              Merit Scholarship
          </Typography>
          <Divider style={{
                backgroundColor: 'rgb(58, 127, 187)',
                opacity: '0.3'
            }} />
        </div>
      <StaticDisplayMerit />
    </Fragment >
  );
}

export default MeritScholarship;